import { CREATE_PROJECT, GET_PROJECT, GET_PROJECTS } from '../types';
import { createAxiosAction } from '../utils';

export default {
  createProject: name => {
    return createAxiosAction({
      url: '/api/v1/projects',
      method: 'POST',
      body: { name },
      startAction: CREATE_PROJECT,
    });
  },
  getProject: projectId => {
    return createAxiosAction({
      url: `/api/v1/projects/${projectId}`,
      startAction: GET_PROJECT,
    });
  },
  getProjects: () => {
    return createAxiosAction({
      url: `/api/v1/projects`,
      startAction: GET_PROJECTS,
    });
  },
};
